import { useQuery } from '@tanstack/react-query';
import { strapiSearchBakuMutus } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

const MIN_QUERY_LEN = 1;

export function bakuMutusSearchMinLength() {
  return MIN_QUERY_LEN;
}

export function useBakuMutusSearchQuery(jwt: string | null, q: string) {
  const trimmed = q.trim();

  return useQuery({
    queryKey: queryKeys.bakuMutusSearch(jwt, trimmed),
    queryFn: () => strapiSearchBakuMutus(jwt!, trimmed),
    enabled: Boolean(jwt && trimmed.length >= MIN_QUERY_LEN),
    staleTime: 15_000,
  });
}
